(function () {
	"use strict";
	let blockwheelsBlocksMasonryGallery = {
		initAll: function () {

			const elementList = document.querySelectorAll(
				'.wp-block-blockwheels-masonry-gallery'
			);

			if (!elementList || elementList.length === 0) {
				return;
			}
			// Masonry Layout
			for ( let i = 0; i < elementList.length; i++ ) {
				let masGrid = new Masonry( elementList[i], {
					itemSelector: '.column'
				} );
				imagesLoaded( elementList[i] ).on( 'progress', function() {
					// layout Masonry after each image loads
					masGrid.layout();
				});
				masGrid.once( 'layoutComplete', function( items ) {
					// Create a new event
					let event = new CustomEvent( 'layoutComplete' );
					elementList[i].dispatchEvent( event );
				});
			}
		},
		// Initiate the menus when the DOM loads.
		init: function () {
			blockwheelsBlocksMasonryGallery.initAll();
		},
	};
	if (document.readyState === "loading") {
		// The DOM has not yet been loaded.
		document.addEventListener("DOMContentLoaded", blockwheelsBlocksMasonryGallery.init);
	} else {
		// The DOM has already been loaded.
		blockwheelsBlocksMasonryGallery.init();
	}
})();